import { render, staticRenderFns } from "./editRecord.vue?vue&type=template&id=f210b720&scoped=true&"
import script from "./editRecord.vue?vue&type=script&lang=js&"
export * from "./editRecord.vue?vue&type=script&lang=js&"
import style0 from "./editRecord.vue?vue&type=style&index=0&id=f210b720&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f210b720",
  null
  
)

export default component.exports